import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent implements OnInit {

  public event: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef,) { }

  message:string =  "";

  ngOnInit(): void {
  }

  okClick() {
    this.bsModalRef.hide();
    this.event.emit(true);
  }
  onCloseClick(){
    this.bsModalRef.hide();
  }
  
}
